import { SET_UTM_MEDIUM_SOURCE_TYPE } from 'actions';

export const setUtmMediumSourceType = (utmMedium: string) => {
  return { type: SET_UTM_MEDIUM_SOURCE_TYPE, utmMedium };
};
